import React, {FC, useState} from 'react';
import {useForm} from 'react-hook-form';
import {useNavigate} from 'react-router-dom';
import {AuthPageLayout} from '../../components/auth-page-layout/auth-page-layout.component';
import {PageTitle} from '../../components/page-title/page-title.component';
import {ResetPasswordModal} from '../../components/reset-password-modal/reset-password-modal.component';
import {ReactComponent as BackArrow} from '../../assets/trak-back-arrow.svg';
import {InputSubmitButton} from '../../components/input-submit-btn/input-submit-btn.component';
import { ApiService } from '../../services/api';

type ForgotPasswordFormValues = {
  email: string;
};

export const ForgotPassword: FC = () => {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: {errors},
    clearErrors
  } = useForm<ForgotPasswordFormValues>();

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const [responseError, setResponseError] = useState<string>();
  const [submitting, setSubmitting] = useState<boolean>(false);

  const resetErrors = () => { 
    setResponseError(undefined);
    clearErrors();
  }

  const onSubmit = handleSubmit(async data => {
    if (submitting) { 
      return;
    }
    try {
      setSubmitting(true);
      const response = await ApiService.sendResetPasswordRequest(data.email);
      if (response) { 
        setResponseError(undefined);
        setModalOpen(true);
      } else { 
        setResponseError('Something went wrong.');
      }

    } catch (e) {
      setResponseError('Your email or password are not correct, please try again or reset your password.');
    } finally { 
      setSubmitting(false);
    }
  });

  return (
    <div className="relative flex flex-1">
      <div className="w-1/4 absolute left-10 top-10 cursor-pointer z-20">
        {<BackArrow className="cursor-pointer" onMouseDown={() => navigate('/', {replace: true})} />}
      </div>
      <AuthPageLayout padTop>
        <PageTitle>Forgot Password</PageTitle>

        <form onSubmit={onSubmit} className="flex flex-col gap-4 my-2">
          <input
            aria-label="Email Address"
            aria-invalid={errors.email ? 'true' : 'false'}
            type="email"
            placeholder="Email Address"
            className={`w-full bg-gray-200 rounded-md px-3 py-4 ${errors?.email && 'border border-trak-red'}`}
            {...register('email', {
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Invalid email address',
              },
              required: {
                value: true,
                message: 'Email address required',
              },
            })}
            onChange={resetErrors}
          />
          {errors?.email && <p className="text-trak-red whitespace-normal">{errors.email.message}</p>}

          {responseError && <p className="text-trak-red whitespace-normal">{responseError}</p>}

          <InputSubmitButton value="Request Reset Link" />
        </form>
      </AuthPageLayout>
      {modalOpen && <ResetPasswordModal />}
    </div>
  );
};
